import { createSelector } from 'reselect'
import { VirtualCardStatus } from 'src/models/virtualCard.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectVirtualCardListModels } from 'src/redux/selectors/data/virtualCards.selectors'
import { VirtualCardsFullPaginatedDataState } from 'src/redux/virtualCardsFullPaginatedData.reducer'

export const selectVirtualCardsFullPaginatedData = (
  state: RootState,
): VirtualCardsFullPaginatedDataState =>
  state.app.search.virtualCardsFullPaginatedData
const selectUniqueVirtualCardIds = createSelector(
  [selectVirtualCardsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueVirtualCardListModels = createSelector(
  [selectUniqueVirtualCardIds, selectVirtualCardListModels],
  (ids, virtualCards) => ids.map((id) => virtualCards[id]),
)
export const selectFilteredVirtualCards = createSelector(
  [selectUniqueVirtualCardListModels],
  (virtualCards) => virtualCards,
)

export const selectFilteredUncancelledVirtualCards = createSelector(
  [selectUniqueVirtualCardListModels],
  (virtualCards) =>
    virtualCards.filter(
      (card) => card.status !== VirtualCardStatus.Cancelled,
      true,
    ),
)
